/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListUserAccessManagementQueryVariables = Types.Exact<{
  input: Types.ListPermissionControlSetsInput;
}>;


export type ListUserAccessManagementQuery = { __typename?: 'Query', listUserPermissionControlSets: Array<{ __typename?: 'PermissionControlSet', permission_control_set_id: string, name: string, description?: string | null, controls: Array<{ __typename?: 'PermissionControl', permission_control_id: string, name: string, description?: string | null, nodes: Array<{ __typename?: 'PermissionControlNode', is_enabled: boolean, scope: Types.PermissionControlScope }> }> }> };

export type UpsertUserAccessManagementMutationVariables = Types.Exact<{
  input: Types.PostUserPermissionGrantsInput;
  owner_user_id: Types.Scalars['String']['input'];
}>;


export type UpsertUserAccessManagementMutation = { __typename?: 'Mutation', postUserPermissionGrants: { __typename?: 'UserModel', user_id: string, account: { __typename?: 'AccountModel', account_id: string, users: Array<{ __typename?: 'UserModel', user_id: string, access_level?: { __typename?: 'UserAccess', level: Types.UserAccessLevel, scopes: Array<Types.PermissionScope> } | null }> } } };

export type RemoveAllUserAccessMutationVariables = Types.Exact<{
  accessing_user_id: Types.Scalars['String']['input'];
  owner_user_id: Types.Scalars['String']['input'];
}>;


export type RemoveAllUserAccessMutation = { __typename?: 'Mutation', deleteUserPermissionGrants?: { __typename?: 'UserModel', user_id: string } | null, updateUserNotificationConnection: { __typename?: 'UserNotificationConnection', user_id: string, email_enabled: boolean, connected_user_id: string } };


export const ListUserAccessManagementDocument = gql`
    query listUserAccessManagement($input: ListPermissionControlSetsInput!) {
  listUserPermissionControlSets(input: $input) {
    permission_control_set_id
    name
    description
    controls {
      permission_control_id
      name
      description
      nodes {
        is_enabled
        scope
      }
    }
  }
}
    `;
export function useListUserAccessManagementQuery(baseOptions: Apollo.QueryHookOptions<ListUserAccessManagementQuery, ListUserAccessManagementQueryVariables> & ({ variables: ListUserAccessManagementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUserAccessManagementQuery, ListUserAccessManagementQueryVariables>(ListUserAccessManagementDocument, options);
      }
export function useListUserAccessManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUserAccessManagementQuery, ListUserAccessManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUserAccessManagementQuery, ListUserAccessManagementQueryVariables>(ListUserAccessManagementDocument, options);
        }
// @ts-ignore
export function useListUserAccessManagementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListUserAccessManagementQuery, ListUserAccessManagementQueryVariables>): Apollo.UseSuspenseQueryResult<ListUserAccessManagementQuery, ListUserAccessManagementQueryVariables>;
export function useListUserAccessManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUserAccessManagementQuery, ListUserAccessManagementQueryVariables>): Apollo.UseSuspenseQueryResult<ListUserAccessManagementQuery | undefined, ListUserAccessManagementQueryVariables>;
export function useListUserAccessManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUserAccessManagementQuery, ListUserAccessManagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUserAccessManagementQuery, ListUserAccessManagementQueryVariables>(ListUserAccessManagementDocument, options);
        }
export type ListUserAccessManagementQueryHookResult = ReturnType<typeof useListUserAccessManagementQuery>;
export type ListUserAccessManagementLazyQueryHookResult = ReturnType<typeof useListUserAccessManagementLazyQuery>;
export type ListUserAccessManagementSuspenseQueryHookResult = ReturnType<typeof useListUserAccessManagementSuspenseQuery>;
export type ListUserAccessManagementQueryResult = Apollo.QueryResult<ListUserAccessManagementQuery, ListUserAccessManagementQueryVariables>;
export const UpsertUserAccessManagementDocument = gql`
    mutation upsertUserAccessManagement($input: PostUserPermissionGrantsInput!, $owner_user_id: String!) {
  postUserPermissionGrants(input: $input) {
    user_id
    account {
      account_id
      users {
        user_id
        access_level(user_id: $owner_user_id) {
          level
          scopes
        }
      }
    }
  }
}
    `;
export type UpsertUserAccessManagementMutationFn = Apollo.MutationFunction<UpsertUserAccessManagementMutation, UpsertUserAccessManagementMutationVariables>;
export function useUpsertUserAccessManagementMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserAccessManagementMutation, UpsertUserAccessManagementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserAccessManagementMutation, UpsertUserAccessManagementMutationVariables>(UpsertUserAccessManagementDocument, options);
      }
export type UpsertUserAccessManagementMutationHookResult = ReturnType<typeof useUpsertUserAccessManagementMutation>;
export type UpsertUserAccessManagementMutationResult = Apollo.MutationResult<UpsertUserAccessManagementMutation>;
export type UpsertUserAccessManagementMutationOptions = Apollo.BaseMutationOptions<UpsertUserAccessManagementMutation, UpsertUserAccessManagementMutationVariables>;
export const RemoveAllUserAccessDocument = gql`
    mutation removeAllUserAccess($accessing_user_id: String!, $owner_user_id: String!) {
  deleteUserPermissionGrants(
    input: {user_id: $owner_user_id, accessing_user_id: $accessing_user_id}
  ) {
    user_id
  }
  updateUserNotificationConnection(
    input: {connected_user_id: $accessing_user_id, email_enabled: false, user_id: $owner_user_id}
  ) {
    user_id
    email_enabled
    connected_user_id
  }
}
    `;
export type RemoveAllUserAccessMutationFn = Apollo.MutationFunction<RemoveAllUserAccessMutation, RemoveAllUserAccessMutationVariables>;
export function useRemoveAllUserAccessMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAllUserAccessMutation, RemoveAllUserAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAllUserAccessMutation, RemoveAllUserAccessMutationVariables>(RemoveAllUserAccessDocument, options);
      }
export type RemoveAllUserAccessMutationHookResult = ReturnType<typeof useRemoveAllUserAccessMutation>;
export type RemoveAllUserAccessMutationResult = Apollo.MutationResult<RemoveAllUserAccessMutation>;
export type RemoveAllUserAccessMutationOptions = Apollo.BaseMutationOptions<RemoveAllUserAccessMutation, RemoveAllUserAccessMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useListUserAccessManagement = withQueryResponseHandler(useListUserAccessManagementQuery);
export const useUpsertUserAccessManagement = withMutationResponseHandler(useUpsertUserAccessManagementMutation, "upsertUserAccessManagement");
export const useRemoveAllUserAccess = withMutationResponseHandler(useRemoveAllUserAccessMutation, "removeAllUserAccess");